import { render } from "./BaseInput.vue?vue&type=template&id=59522e7a&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=ts"
export * from "./BaseInput.vue?vue&type=script&lang=ts"

import "./BaseInput.vue?vue&type=style&index=0&id=59522e7a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-59522e7a"

export default script